<template>
  <div class="container mt-4">
    <h2>Cadastro de Serviço</h2>

    <b-form @submit.prevent="submitForm">
      <b-row>
        <b-col cols="8">
          <b-form-group label-for="name" label="Nome">
            <b-form-input
              v-model="product.name"
              type="text"
              id="name"
              placeholder="Informe o nome do serviço"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <b-form-group label-for="code" label="Código">
            <b-form-input
              v-model="product.code"
              :state="product.code != null && product.code.trim().length > 0"
              type="text"
              id="code"
              placeholder="Informe o código do serviço"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="8">
          <b-form-group label-for="productType" label="Tipo do Serviço">
            <b-form-select
              v-model="product.productType"
              :options="serviceTypeOptions"
              placeholder="Informe o tipo do serviço"
              :state="!!product.productType"
              id="productType"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-for="status" label="Status">
            <b-form-checkbox v-model="product.active" id="status" switch>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label-for="price" label="Preço">
            <base-input-numeric
              :value.sync="product.price"
            ></base-input-numeric>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label-for="cost" label="Custo médio">
            <base-input-numeric :value.sync="product.cost"></base-input-numeric>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label-for="description" label="Descrição">
            <b-form-textarea
              v-model="product.description"
              id="description"
              placeholder="De uma breve descrição do serviço prestado"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <h3 @click="collapsetax = !collapsetax" style="cursor: pointer;">
        Dados Fiscais
        <i
          :class="
            collapsetax
              ? 'tim-icons icon-minimal-up'
              : 'tim-icons icon-minimal-down'
          "
        ></i>
      </h3>

      <b-collapse id="collapse-tax" v-model="collapsetax">
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="serviceType" label="CNAE principal">
              <b-form-input
                v-model="product.cnae"
                type="text"
                id="code"
                placeholder="Informe o CNAE principal"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label-for="operationNature"
              label="Natureza de Operação"
            >
              <b-form-select
                v-model="product.operationNature"
                :options="operationNatureOptions"
                id="operationNature"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group
              label-for="municipalServiceCode"
              label="Cód. de serviço municipal"
            >
              <b-form-input
                v-model="product.municipalServiceCode"
                type="text"
                id="municipalServiceCode"
                placeholder="Informe o código de serviço municipal"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label-for="lc116Code"
              label="Cód. de Lei Complementar 116"
            >
              <b-form-input
                v-model="product.lc116Code"
                type="text"
                id="lc116Code"
                placeholder="Informe o código da lei complementar 116"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
      <hr />
      <h3 @click="collapsetaxes = !collapsetaxes" style="cursor: pointer;">
        Principais impostos
        <i
          :class="
            collapsetaxes
              ? 'tim-icons icon-minimal-up'
              : 'tim-icons icon-minimal-down'
          "
        ></i>
      </h3>

      <b-collapse id="collapse-tax" v-model="collapsetaxes">
        <b-row>
          <b-col>
            <b-form-group
              label-for="serviceExecutionLocation"
              label="Local de prestação do serviço"
            >
              <b-form-select
                v-model="product.serviceExecutionLocation"
                :options="stateOptions"
                id="serviceExecutionLocation"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="iss" label="IIS">
              <b-form-input
                v-model="product.iss"
                type="text"
                id="iss"
                placeholder="Informe o iss"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label-for="inss" label="INSS">
              <b-form-input
                v-model="product.inss"
                type="text"
                id="inss"
                placeholder="Informe o inss"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="2">
            <b-form-group label-for="iisStatus" label="IIS Retido">
              <b-form-checkbox
                v-model="product.iisStatus"
                id="iisStatus"
                switch
              >
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
      <b-button variant="primary" @click="addNewService">
        Salvar
      </b-button>

      <fade-alert-danger
        ref="fadeAlertDanger"
        :msg="alert.error"
      ></fade-alert-danger>
      <success-fade-alert
        ref="successFadeAlert"
        :msg="alert.success"
      ></success-fade-alert>
    </b-form>
  </div>
</template>
<script>
import BaseInputNumeric from "../../../../components_rms/base/BaseInputNumeric.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "ServiceCrud",
  components: {
    BaseInputNumeric,
    FadeAlertDanger,
    SuccessFadeAlert
  },
  data() {
    return {
      alert: {
        error: "Verifique os dados informados",
        success: "Serviço cadastrado com sucesso!"
      },
      product: {
        id: null,
        name: "",
        code: "",
        barCode: "",
        price: 0,
        unit: "",
        description: "",
        availableQty: 0,
        reservedQty: 0,
        totalQty: 0,
        productFamilyId: null,
        category: "",
        cost: 0,
        type: 0,
        sku: "6",
        cest: "",
        ncm: "",
        productType: null,
        origin: 0,
        taxRulesNcm: [],
        taxRulesProduct: [],
        operationNature: null,
        cnae: null,
        lc116Code: null,
        municipalServiceCode: null,
        active: true,
        iisStatus: false,
        serviceExecutionLocation: null,
        iss: 0,
        inss: 0
      },
      serviceTypeOptions: [
        { value: "11", text: "Prestado" },
        { value: "12", text: "Tomado" },
        { value: "13", text: "Prestado e Tomado" }
      ],
      stateOptions: [],
      operationNatureOptions: [
        { value: "1", text: "Tributada integralmente" },
        { value: "2", text: "Isenta" },
        { value: "3", text: "Não tributada - ISS regime fixo" },
        {
          value: "4",
          text: "Tributada integralmente e sujeita à substituição tibutária"
        },
        { value: "5", text: "Não tributada" },
        { value: "6", text: "Tributada integralmente com ISSRF" },
        { value: "7", text: "Tributada com redução da base de cálculo" },
        {
          value: "8",
          text: "Tributada com redução da base de cálculo com ISSRF"
        },
        {
          value: "9",
          text:
            "Tributada com redução da base de cálculo e sujeita a substituição tributária"
        },
        { value: "0", text: "Não tributada - ISS regime estimativa" },
        {
          value: "11",
          text: "Não tributada - ISS contrução civil recolhido antecipadamente"
        },
        { value: "12", text: "Não tributada - Ato Cooperado" }
      ],
      collapsetax: false,
      collapsetaxes: false
    };
  },
  created() {
    if (this.$route?.params?.rowData)
      this.product = JSON.parse(this.$route.params.rowData);
  },
  methods: {
    validateService() {
      const errors = [];

      if (!this.product.code || !this.product.code.trim()) {
        errors.push("Por favor, insira um código.");
      }

      if (!this.product.productType) {
        errors.push("Por favor, selecione o Tipo de serviço.");
      }

      return errors;
    },

    addNewService() {
      const validationErrors = this.validateService();

      if (validationErrors.length) {
        this.alert.error = validationErrors[0];
        this.$refs.fadeAlertDanger.show();
        return;
      }
      if (!this.$route.params.edit) {
        this.$apiScheduler
          .post("/product/create", this.product)
          .then(response => {
            this.$refs.successFadeAlert.show();
          })
          .catch(error => {
            this.alert.error = error.response.data.split("-")[0];
            this.$refs.fadeAlertDanger.show();
          });
      } else {
        this.$apiScheduler
          .post("/product/edit", this.product)
          .then(response => {
            this.$refs.successFadeAlert.show();
          })
          .catch(error => {
            this.alert.error = error.response.data.split("-")[0];
            this.$refs.fadeAlertDanger.show();
          });
      }
    },
    async getAllStates() {
      try {
        const response = await this.$apiScheduler.get(`/system/state/1`);
        this.stateOptions = [...response.data];
      } catch (error) {
        console.error("Erro ao carregar estados:", error);
      }
    }
  },
  mounted() {
    this.getAllStates();
  }
};
</script>
